/* ==========================================================================
   Thornhill's Pharmacy — Campaign LP (Shopify)
   - FAQ accordion (single-open)
   - Conditions show/hide
   - GA4 + Google Ads conversion tracking
   - Footer year
   ========================================================================== */
(function () {
  "use strict";

  // ---------- Footer year ----------
  document.querySelectorAll("[data-campaign-year]").forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });

  // ---------- Sticky Header (Reduced Nav) ----------
  var header = document.querySelector(".c-header");
  if (header) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 50) {
        header.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
      }
    }, { passive: true }); // 'passive' improves scroll performance
  }  

  // ---------- Conditions toggle ----------
  document.querySelectorAll("[data-campaign-conditions]").forEach(function (root) {
    var toggle = root.querySelector("[data-campaign-toggle]");
    var extras = root.querySelectorAll("[data-extra]");
    if (!toggle || !extras.length) return;
    var open = false;
    var labelMore = toggle.getAttribute("data-label-more") || "View all categories";
    var labelLess = toggle.getAttribute("data-label-less") || "Show fewer";
    toggle.addEventListener("click", function () {
      open = !open;
      extras.forEach(function (el) {
        el.hidden = !open;
      });
      toggle.textContent = open ? labelLess : labelMore;
    });
  });

  // ---------- FAQ accordion ----------
  document.querySelectorAll("[data-campaign-faq]").forEach(function (list) {
    list.addEventListener("click", function (e) {
      var btn = e.target.closest(".c-faq__q");
      if (!btn || !list.contains(btn)) return;
      var item = btn.parentElement;
      var p = item.querySelector(".c-faq__a");
      var icon = btn.querySelector(".c-faq__q-icon");
      var isOpen = !p.hidden;
      list.querySelectorAll(".c-faq__a").forEach(function (el) {
        el.hidden = true;
      });
      list.querySelectorAll(".c-faq__q-icon").forEach(function (el) {
        el.textContent = "+";
      });
      list.querySelectorAll(".c-faq__q").forEach(function (el) {
        el.setAttribute("aria-expanded", "false");
      });
      if (!isOpen) {
        p.hidden = false;
        icon.textContent = "−";
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });

  // ---------- Analytics: GA4 + Google Ads ----------
  // TODO: paste your Google Ads ID + per-conversion labels to activate.
  var GA4 = "G-WRS5HQ910C";
  var ADS_ID = ""; // e.g. "AW-1234567890"
  var LABELS = { formSubmit: "", phoneCall: "", callbackRequest: "" };

  var loaderId = ADS_ID || GA4;
  if (loaderId && !window.gtag) {
    var s = document.createElement("script");
    s.async = true;
    s.src = "https://www.googletagmanager.com/gtag/js?id=" + loaderId;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    if (ADS_ID) window.gtag("config", ADS_ID);
    if (GA4) window.gtag("config", GA4);
  }

  function track(label, ga4Event, params) {
    params = params || {};
    if (!window.gtag) return;
    if (ADS_ID && label) {
      window.gtag(
        "event",
        "conversion",
        Object.assign({ send_to: ADS_ID + "/" + label }, params),
      );
    }
    if (GA4) window.gtag("event", ga4Event, params);
  }

  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a");
    if (!a) return;
    var href = a.getAttribute("href") || "";
    if (href.indexOf("tel:") === 0) track(LABELS.phoneCall, "phone_call_click");
    else if (href === "#partner-form") track(LABELS.callbackRequest, "callback_request_click");
  });

  window.addEventListener("message", function (e) {
    if (typeof e.origin !== "string" || e.origin.indexOf("typeform.com") === -1) return;
    var d = e.data;
    var name =
      (typeof d === "object" && d && (d.type || d.eventName)) ||
      (typeof d === "string" ? d : "");
    if (typeof name === "string" && /form[-_]?submit/i.test(name)) {
      track(LABELS.formSubmit, "generate_lead", { form: "typeform" });
    }
  });
})();
